type GetPos = () => number | undefined;

type HostWithGetPos = HTMLElement & { lineWrapperGetPos?: GetPos };

/** Stash a node view's `getPos` on a DOM host so overlays outside the view can read it back. */
export function setLineWrapperGetPos(el: HTMLElement, getPos: GetPos): void {
  (el as HostWithGetPos).lineWrapperGetPos = getPos;
}

export function getLineWrapperGetPos(el: HTMLElement): GetPos | undefined {
  return (el as HostWithGetPos).lineWrapperGetPos;
}
